export const handleCheckboxChange = (
    newValue: string,
    currentValues: string[],
    setter: (values: string[]) => void,
) => {
    if (currentValues.includes(newValue)) {
        setter(currentValues.filter((m: string) => m !== newValue));
    } else {
        setter([...currentValues, newValue]);
    }
};
